import * as CONST from '../../constants';

const INITIAL_STATE = { loading: true, data: [], error: null };

export const cityList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONST.CITY_LIST_REQUEST:
      return { ...INITIAL_STATE, loading: true, data: [], error: null };
    case CONST.CITY_LIST_SUCCESS:
      return { ...INITIAL_STATE, loading: false, data: action.data.data };
    case CONST.CITY_LIST_ERROR:
      return { ...INITIAL_STATE, loading: false, error: action.error };
    default:
      return state;
  }
};
